import Loader from "react-loader-spinner";
import { faTimes, faWarehouse } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Fragment, useEffect, useRef, useState } from "react";
import { Alert, Button, Col, Form, Modal, Row, Table } from "react-bootstrap";
import { searchStorage4Modal, addEditStorage, deleteStorage } from "../store/api/StorageApi";
import { CheckLg, DashCircle, ExclamationTriangle, Pencil, PlusSquare, PlusSquareFill, Trash } from "react-bootstrap-icons";

const ModalStorageManagement = (props) => {
    const { popData, setPopData } = props;
    const iconClicked = useRef(false);
    const [currentStorage, setCurrentStorage] = useState(null);
    const [stgList, setStgList] = useState({ Data: [] });
    const [error, setError] = useState(null);
    function close() {
        setPopData({
            show: false
        })
    }
    function rowClick(row) {
        if (iconClicked.current) {
            iconClicked.current = false;
            return;
        }
        setCurrentStorage(row);
    }
    function prepareForAdd() {
        setCurrentStorage({
            StorageID: 0
        })
    }
    function addEdit() {
        setError(null);
        const onAddEdit = (res) => {
            if (res.Error) {
                setError(res.Error);
            }
            else if (res.Data) {
                if (Number(currentStorage.StorageID) > 0) {
                    const stg = stgList.Data.find(s => Number(s.StorageID) === Number(currentStorage.StorageID));
                    stg.StorageName = currentStorage.StorageName;
                }
                else {
                    currentStorage.StorageID = res.Data;
                    stgList.Data.push(currentStorage);
                }
                setCurrentStorage(null);
                setStgList({ ...stgList });
            }
        }
        addEditStorage(currentStorage, onAddEdit);
    }
    function delStg(id) {
        iconClicked.current = true;
        const onDelete = (res) => {
            if (res.Error) {
                setError(res.Error);
            }
            else if (res.Data) {
                stgList.Data = stgList.Data.filter(s => Number(s.StorageID) !== Number(id));
                setStgList({ ...stgList });
            }
        }
        deleteStorage(id, onDelete);
    }
    function cancelStg() {
        setCurrentStorage(null);
    }
    useEffect(() => {
        if (popData.show) {
            searchStorage4Modal("", 0, setStgList);
        }
    }, [popData.show])

    return (
        <Modal show={popData.show} onHide={() => { }}>
            <Modal.Header className="headerStyle">
                <span>
                    <FontAwesomeIcon icon={faWarehouse} size="lg" />&nbsp;
                    مدیریت انبارها
                </span>
                <FontAwesomeIcon icon={faTimes} size="lg" onClick={close} />
            </Modal.Header>
            <Modal.Body className="bodyStyle">
                {error &&
                    <Alert variant="danger" style={{paddingLeft:"20px"}}>
                        <ExclamationTriangle size={18} />&nbsp;
                            {error}
                        <FontAwesomeIcon icon={faTimes} size="lg" style={{ float: "left", position:"absolute", left:10, top:15 }} onClick={() => setError(null)} />
                    </Alert>}
                {currentStorage &&
                    <Row className="rowBorder" style={{ margin: 0 }}>
                        <Col md={5} className="form-group">
                            <label>نام انبار: </label>
                            <Form.Control defaultValue={currentStorage.StorageName ?? ""} onChange={e => currentStorage.StorageName = e.target.value} />
                        </Col>
                        <Col md={7} className="form-group">
                            <label>نشانی انبار</label>
                            <Form.Control defaultValue={currentStorage.StorageAddress ?? ""} onChange={e => currentStorage.StorageAddress = e.target.value} />
                        </Col>
                        <div className="mt-2">
                            <Button className="group-Btn" variant="success" onClick={addEdit}>
                                {
                                    Number(currentStorage.StorageID) > 0 &&
                                    <Fragment>
                                        <Pencil size={16} />&nbsp;
                                        ویرایش انبار
                                    </Fragment>
                                }
                                {
                                    Number(currentStorage.StorageID) === 0 &&
                                    <Fragment>
                                        <CheckLg size={15} />&nbsp;
                                        ثبت انبار
                                    </Fragment>
                                }
                            </Button>
                            <Button className="group-Btn" variant="danger" onClick={cancelStg}>
                                <DashCircle size={17} />&nbsp; انصراف
                            </Button>
                        </div>
                    </Row>
                }
                {
                    !currentStorage &&
                    <Button className="mb-1 group-Btn-smalll" onClick={prepareForAdd} >
                        <PlusSquare className="hoverIcon" size={21} />
                    </Button>
                }
                {!currentStorage &&

                    <Table responsive className="fixedHeightTable" style={{ whiteSpace: "nowrap" }}>
                        <thead>
                            <th style={{ position: "sticky", top: 0, zIndex: 50, backgroundColor: "#b6b6b6", padding: "8px" }}>نام انبار</th>
                            <th style={{ position: "sticky", top: 0, zIndex: 50, backgroundColor: "#b6b6b6", padding: "8px" }}>نشانی انبار</th>
                            <th style={{ position: "sticky", top: 0, zIndex: 50, backgroundColor: "#b6b6b6", padding: "8px" }}>&nbsp;</th>
                        </thead>
                        <tbody>
                            {!Array.isArray(stgList?.Data ?? "") &&
                                <tr>
                                    <td colSpan={3} style={{ textAlign: "center", width: "100%" }}>
                                        <Loader type="BallTriangle" color="#bb1370" width={20} height={20} />
                                    </td>
                                </tr>
                            }
                            {Array.isArray(stgList?.Data ?? "") &&
                                stgList.Data.map((stg, i) =>
                                    <tr key={i} onClick={() => rowClick(stg)} className="resultTableRow">
                                        <td>{stg.StorageName}</td>
                                        <td>{stg.StorageAddress}</td>
                                        <td><Trash size={18} color="red" onClick={() => delStg(stg.StorageID)} /></td>
                                    </tr>)
                            }
                        </tbody>
                    </Table>
                }
            </Modal.Body>
        </Modal>
    )

}
export default ModalStorageManagement;